import { combineSlices, configureStore } from '@reduxjs/toolkit';

import { agentsApi } from '@/features/agents/agentsApi';

// The session (GSB-7774) keeps its state in React; the agents service is the only slice.
const store = configureStore({
  reducer: combineSlices(agentsApi),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(agentsApi.middleware),
});

export default store;
